import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';

export const Route = createFileRoute('/(client)/files')({
  component: () => (
    <PageContainer>
      <Outlet />
    </PageContainer>
  ),
});
